import { useRef, useState } from "react";
import Form from "../../../../../components/common/form/Form";
import Modal from "../../../../../components/common/form/Modal";
import ButtonTray from "../../../../../components/common/form/ButtonTray";
import TextAreaField from "../../../../../components/common/form/TextAreaField";
import { handleRTKQuery } from "../../../../../helpers/utils/RtkQueryUtils";
import { useCreateAssociationNoteApiMutation } from "../../associationApi";

interface NoteAddSectionProps {
    show: boolean;
    setShow: (value: boolean) => void;
    title: string;
    associationId?: any;
    noteType?: string;
    types?: string[];
    isHoaEditor?: boolean;
}

export function NoteAddSection({
    show,
    setShow,
    title,
    associationId,
    noteType,
    types,
    isHoaEditor
}: NoteAddSectionProps): JSX.Element {

    const [noteBody, setNoteBody] = useState<string>("");
    const [disable, setDisable] = useState<boolean>(false);
    const [createNote, createNoteApi] = useCreateAssociationNoteApiMutation();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (noteBody) {
            setDisable(true);
            const noteDto = {
                associationId: associationId,
                message: noteBody
            };
            handleRTKQuery(
                () => createNote({ associationId: associationId, requestBody: noteDto }),
                () => setShow(false)
            );

        }
    };

    return (
        <>
            <Modal
                title={title}
                show={show}
                setShow={setShow}
                className={"w-2/6 bg-text-0 text-surface-0"}
                hoa={isHoaEditor}
                fields={

                    <Form
                        onSubmit={handleSubmit}
                        fields={
                            <>
                                <div className="modal-body">
                                    <TextAreaField

                                        value={noteBody}
                                        placeholder="Enter Note Body...."
                                        rows={5}
                                        name="noteBody"
                                        hidelabel
                                        onChange={(e) => setNoteBody(e.target.value)}
                                        required
                                    />
                                </div>
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "cancel",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Add Note",
                                                type: "submit",
                                                isLoading: createNoteApi.isLoading,
                                                isDisabled: disable,
                                                isHoa: isHoaEditor
                                            },

                                            buttonType: "button"
                                        },


                                    ]}

                                    align={"start"}
                                    gap={2}

                                />

                            </>
                        }
                    />

                }
            />
        </>
    );
}
